import * as React from 'react';
import { FComponent } from '../../../types/common';
import { Breadcrumb } from '../Breadcrumb';
import { Crumb } from '../Breadcrumb/Breadcrumb';
import NotFound from '../Icons/NotFound';

const DataNotFound: FComponent<{
  itemName: string;
  crumbs?: Crumb[];
}> = ({ itemName, crumbs = [] }) => {
  return (
    <div className="full-page-error">
      {crumbs.length > 0 ? <Breadcrumb crumbs={crumbs} /> : null}
      <NotFound className="not-found" />
      <div className="message">
        We couldn&apos;t load this {itemName}, we are looking into it.
      </div>
    </div>
  );
};

export { DataNotFound };
